export default __webpack_public_path__ + "static/media/tastimonials-img.5ff7ad70.png";